// extracted by mini-css-extract-plugin
export default {"objetsscene":"InfoBox_objetsscene__T30j6","hidden":"InfoBox_hidden__FtL63","infoBox":"InfoBox_infoBox__8jCUY"};